<template>
    <div>
        <loading v-if="loading"></loading>
        <vue-apex-charts v-if="!loading" type="bar" height="400" :options="chartOptions" :series="series"></vue-apex-charts>
    </div>
</template>
<script>
    // import initFilterModel from '@/shared/filter';
    // import {formatDate, parseDate} from '@/shared/utils';
    import VueApexCharts from 'vue-apexcharts'
    import CurrencyFilter from '@/shared/filters/currency';
    import Loading from '@/views/Loading';


    // export const
    export default {
        name: "HorizontalBarChart",
        props: {
            data: Object,
            title: String,
            organizationType: String
        },
        components: {
            VueApexCharts,
            Loading
        },
        data() {
            return {
                loading: false,
                series: [
                    {
                        name: 'Хизмат хакки',
                        type: 'column',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    },
                    {
                        name: 'Туланган',
                        type: 'column',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    },
                    {
                        name: 'Туланмаган',
                        type: 'column',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    }
                ],
                chartOptions: {
                    title: {
                        text: this.$props.title,//'Авто ва Асбоб-ускуналар (Ташкилотлар буйича)',
                        align: 'left',
                        offsetX: 110
                    },
                    tooltip: {
                        y: {
                            formatter: function(val) {
                                return CurrencyFilter(val, '', 2, { thousandsSeparator: ' ' });
                            },
                            title: {
                                formatter: function (seriesName) {
                                    return seriesName + ''
                                }
                            }
                        }
                        // custom: function ({series, /*seriesIndex, dataPointIndex, w*/}) {
                        //     return "<div>" + series + "</div>";
                        // }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'flat',
                            columnWidth: '50px',
                            barHeight: '50px',
                            distributed: false,
                            colors: {
                                ranges: [{
                                    from: 0,
                                    to: 0,
                                    color: undefined
                                }],
                                backgroundBarColors: [],
                                backgroundBarOpacity: 1,
                            },
                            dataLabels: {
                                position: 'top',
                                maxItems: 100,
                                hideOverflowingLabels: true
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false,
                        offsetX: -6,
                        style: {
                            fontSize: '12px',
                            colors: ['#fff']
                        }
                    },
                    stroke: {
                        show: true,
                        width: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
                        colors: ['#fff']
                    },

                    xaxis: {
                        categories: [
                            "Андижон",
                            "Бухоро",
                            "Жиззах",
                            "Қашқадарё",
                            "Қорақалпоғистон",
                            "Навоий",
                            "Наманган",
                            "Самарқанд",
                            "Сирдарё",
                            "Сурхондарё",
                            "Тошкент вилояти",
                            "Тошкент",
                            "Фарғона",
                            "Хоразм"],
                    },
                }
            }
        },
        methods: {
            initList() {

            }
        },
        created() {
            this.initList();

            this.$eventBus.$on('refreshHorizontalBarChart', (data) => {
                this.chartOptions = {
                    title: {
                        text: data.barTitle,
                        align: 'left',
                        offsetX: 110
                    }
                };

            });
        },
        computed: {

        },
        watch: {
            data: function(newVal, /*oldVal*/) { // watch it
                if (newVal) {
                    const object = newVal;
                    // console.log(object);
                    const contractAmountTotal = object;//object.contractAmountTotal;
                    // console.log(this.$props.month);
                    this.loading = true;

                    if (this.$props.organizationType!=null) {
                        this.series = [
                            {
                                name: 'Хизмат хакки',
                                type: 'column',
                                data: [
                                    contractAmountTotal[this.$props.organizationType].provinces['Andijan'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Bukhara'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Jizzakh'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Kashkadarya'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Karakalpakstan'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Navaiy'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Namangan'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Samarkand'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Sirdarya'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Surkhandarya'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['TashkentRegion'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Tashkent'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Fergana'].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces['Khwarazm'].contractAmount,
                                ]
                            },
                            {
                                name: 'Туланган',
                                type: 'column',
                                data: [
                                    contractAmountTotal[this.$props.organizationType].provinces['Andijan'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Bukhara'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Jizzakh'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Kashkadarya'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Karakalpakstan'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Navaiy'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Namangan'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Samarkand'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Sirdarya'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Surkhandarya'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['TashkentRegion'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Tashkent'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Fergana'].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Khwarazm'].paid,
                                ]
                            },
                            {
                                name: 'Туланмаган',
                                type: 'column',
                                data: [
                                    contractAmountTotal[this.$props.organizationType].provinces['Andijan'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Bukhara'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Jizzakh'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Kashkadarya'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Karakalpakstan'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Navaiy'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Namangan'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Samarkand'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Sirdarya'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Surkhandarya'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['TashkentRegion'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Tashkent'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Fergana'].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces['Khwarazm'].unpaid,
                                ]
                            }
                        ];
                    } else { //by default
                        this.series = [
                            {
                                name: 'Хизмат хакки',
                                type: 'column',
                                data: [
                                    contractAmountTotal.ALL.provinces['Andijan'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Bukhara'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Jizzakh'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Kashkadarya'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Karakalpakstan'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Navaiy'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Namangan'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Samarkand'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Sirdarya'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Surkhandarya'].contractAmount,
                                    contractAmountTotal.ALL.provinces['TashkentRegion'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Tashkent'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Fergana'].contractAmount,
                                    contractAmountTotal.ALL.provinces['Khwarazm'].contractAmount,
                                ]
                            },
                            {
                                name: 'Туланган',
                                type: 'column',
                                data: [
                                    contractAmountTotal.ALL.provinces['Andijan'].paid,
                                    contractAmountTotal.ALL.provinces['Bukhara'].paid,
                                    contractAmountTotal.ALL.provinces['Jizzakh'].paid,
                                    contractAmountTotal.ALL.provinces['Kashkadarya'].paid,
                                    contractAmountTotal.ALL.provinces['Karakalpakstan'].paid,
                                    contractAmountTotal.ALL.provinces['Navaiy'].paid,
                                    contractAmountTotal.ALL.provinces['Namangan'].paid,
                                    contractAmountTotal.ALL.provinces['Samarkand'].paid,
                                    contractAmountTotal.ALL.provinces['Sirdarya'].paid,
                                    contractAmountTotal.ALL.provinces['Surkhandarya'].paid,
                                    contractAmountTotal.ALL.provinces['TashkentRegion'].paid,
                                    contractAmountTotal.ALL.provinces['Tashkent'].paid,
                                    contractAmountTotal.ALL.provinces['Fergana'].paid,
                                    contractAmountTotal.ALL.provinces['Khwarazm'].paid,
                                ]
                            },
                            {
                                name: 'Туланмаган',
                                type: 'column',
                                data: [
                                    contractAmountTotal.ALL.provinces['Andijan'].unpaid,
                                    contractAmountTotal.ALL.provinces['Bukhara'].unpaid,
                                    contractAmountTotal.ALL.provinces['Jizzakh'].unpaid,
                                    contractAmountTotal.ALL.provinces['Kashkadarya'].unpaid,
                                    contractAmountTotal.ALL.provinces['Karakalpakstan'].unpaid,
                                    contractAmountTotal.ALL.provinces['Navaiy'].unpaid,
                                    contractAmountTotal.ALL.provinces['Namangan'].unpaid,
                                    contractAmountTotal.ALL.provinces['Samarkand'].unpaid,
                                    contractAmountTotal.ALL.provinces['Sirdarya'].unpaid,
                                    contractAmountTotal.ALL.provinces['Surkhandarya'].unpaid,
                                    contractAmountTotal.ALL.provinces['TashkentRegion'].unpaid,
                                    contractAmountTotal.ALL.provinces['Tashkent'].unpaid,
                                    contractAmountTotal.ALL.provinces['Fergana'].unpaid,
                                    contractAmountTotal.ALL.provinces['Khwarazm'].unpaid,
                                ]
                            }
                        ];
                    }
                    this.loading = false;

                    // this.series = [{
                    //     data: [
                    //         500, 55, 41, 64, 22, 43, 21
                    //     ]
                    // }];
                }

            }
        }
    }
</script>
<style>

</style>

